<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'服務紀錄範本列表'"></page-title>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="$router.push(`/record-template-group/${groupID}`)">修改服務紀錄範本類別</md-button>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>服務紀錄範本名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="clearAll">清除搜尋結果</md-button>
          <md-button class="md-raised md-primary" @click="$router.push(`/record-template-group/${groupID}/record-template/add`)">新增服務紀錄範本</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="getRecordTemplates()">搜尋</md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-table>
            <md-table-row>
              <md-table-head>名稱</md-table-head>
            </md-table-row>
            <md-table-row v-for="(recordTemplate, index) in recordTemplates" :key="recordTemplate.id">
              <md-table-cell>
                <router-link :to="`/record-template-group/${groupID}/record-template/${recordTemplate.id}`">
                  {{recordTemplate.name}}
                </router-link>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <paginate
            :page-count="Math.ceil(pageCount / 20)"
            :click-handler="getRecordTemplates"
            :prev-text="'前頁'"
            :next-text="'下頁'"
            :container-class="'pagination'"
            :no-li-surround="true"
          >
          </paginate>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="$router.back()">返回</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'
import Paginate from 'vuejs-paginate'

export default {
  data () {
    return {
      pageCount: 0,
      data: {
        name: null
      },
      recordTemplates: [],
      groupID: null
    }
  },
  components: {
    PageTitle, Paginate
  },
  created () {
    this.groupID = this.$route.params.groupID
    this.getRecordTemplates()
  },
  methods: {
    clearAll: async function () {
      this.recordTemplates = []
    },
    getRecordTemplates: async function (page = 1) {
      for (var i in this.data) {
        if (this.data[i] === '') {
          this.data[i] = null
        }
      }
      let req = await axios.get(urls({route: `record-template-group/${this.groupID}/record-template`}), {params: {...this.data, page}})
      this.recordTemplates = req.data.data
      this.pageCount = req.data.count
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/RecordTemplate/RecordTemplateList.vue